import { render, staticRenderFns } from "./YpSingleUpload.vue?vue&type=template&id=704af731&scoped=true&"
import script from "./YpSingleUpload.vue?vue&type=script&lang=js&"
export * from "./YpSingleUpload.vue?vue&type=script&lang=js&"
import style0 from "./YpSingleUpload.vue?vue&type=style&index=0&id=704af731&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704af731",
  null
  
)

export default component.exports